<template>
  <div class="filtro-pendente">
    <collapse-default id="filtro_frente_caixa">
      <template v-slot:header>
        Filtros
      </template>
      <template v-slot:content>
        <div class="mt-4 ml-3 mb-4">
          <b-form-group>
            <b-form-radio-group
              :options="optionsTipo"
              name="radio-inline"
              @change="handlerFiltro($event, 'tipoServico')" />
          </b-form-group>
          <div class="container mt-4">
            <div class="row">
              <div class="col-3">
                <label for="filterData">Data</label>
                <b-form-input
                  id="filterData"
                  value=""
                  type="date"
                  @change="handlerFiltro($event, 'data')" />
              </div>
              <div v-if="filtroStore.tipoServico == 'OS'"
                   class="col-3">
                <label for="filterOsPedido">Número O.S</label>
                <b-form-input
                  id="filterOsPedido"
                  value=""
                  type="text"
                  @change="handlerFiltro($event, 'numOs')" />
              </div>
              <div v-show="filtroStore.tipoServico != 'recebimentosAvulso'"
                   class="col-4">
                <label for="filterOsPedido">{{ filtroStore.tipoServico == 'pagamentosAvulso' ?
                  'Beneficiario' : 'Solicitante' }}</label>
                <b-form-input
                  id="filterOsPedido"
                  :value="filtroStore.solicitante"
                  type="text"
                  @change="handlerFiltro($event, 'solicitante')" />
              </div>
              <div v-if="filtroStore.status === 'concluido'"
                   class="col-3 align-self-center">
                <label for="">Forma de pagamento</label>
                <b-form-select
                  value=""
                  :options="optionsFormaPg"
                  class="align-self-center"
                  value-field="item"
                  text-field="name"
                  disabled-field="notEnabled"
                  @change="handlerFiltro($event, 'formaPg')" />
              </div>
              <div class="col-2 d-flex align-items-end  ">
                <b-button class="pl-5 pr-5"
                          @click="filtroListar">
                  Listar
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </template>
    </collapse-default>
    <Pagination
      class="mt-5 mb-5"
      :per-page="filtroStore.perPage"
      :page="filtroStore.page"
      :last-page="filtroStore.lastPage"
      @onPreviousPage="previousPage"
      @onNextPage="nextPage" />
  </div>
</template>

<script>
  // Components
  import CollapseDefault from '../../../../components/SofiaRei/Resumo/Collapses/CollapseDefault.vue'
  import Pagination from '../../../../components/SofiaRei/Pagination.vue'

  // Services
  import pedidoService from '../pedidoService'


  // Outros
  import moment  from "moment"
  import lancamentoService from '../lancamentoService'
  

  export default ({
    name: 'FiltroPendentes',
    components: {
      CollapseDefault,
      Pagination,
    },
    data () {
      return {
        dataFinanceiro: {
          pedidos: null,
          formaPg: null,
          tipoPg: null,
          pagamentosAvulso: null,
          sangriaCx: null
        },
        optionsFormaPg: [
          {item: "Dinheiro", name: "Dinheiro"},
          {item: "Cartão de Crédito", name: "Cartão de Crédito"},
          {item: "Cartão de Debito", name: "Cartão de Debito"},
          {item: "PIX", name: "PIX"},
          {item: "Cheque", name: "Cheque"},
          {item: "Outros", name: "Outros"},  
        ],
        optionsTipo: [
          { text: 'Todos', value: 'todos' },
          { text: 'Ordens de Serviço', value: 'OS' },
          { text: 'Recebimentos Avulsos', value: 'recebimentosAvulso' },
          { text: 'Despesas', value: 'pagamentosAvulso' }
        ]
      }
    },
    computed: {
      status () {
        return this.$store.state.frenteCaixa.filtro.status
      },
      cxData () {
        return this.$store.state.frenteCaixa.cxData
      },
      cxPedidos () {
        return this.$store.state.frenteCaixa.pedidos
      },
      cxSaldo () {
        return this.$store.state.frenteCaixa.saldoDia
      },
      cxGastos () {
        return this.$store.state.frenteCaixa.gastosDia
      },
      atualizarPedidos () {
        // Boolean - serve apenas para atualizar lista e saldo sempre que valor muda true/false
        return this.$store.state.frenteCaixa.atualizarPedidos
      },
      caixa () {
        return this.$store.state.frenteCaixa.caixa
      },
      filtroStore () {
        return this.$store.state.frenteCaixa.filtro
      },
    },
    
    watch: {
      async 'filtroStore.page' () {
        await this.filtroListar()
      },
      async caixa () {
        await this.filtroListar()
      },
      async atualizarPedidos () {
        await this.filtroListar()
      }
      
    },
    async created () {
      // salva data atual no Store do Frente de Caixa
      if (!this.cxData) {
        const date = moment().format('YYYY-MM-DD')
        this.$store.dispatch('frenteCaixa/atualizarCxData', date)
      }
      // Lista os pedidos iniciais ('pendente', 'data atual')
      await this.filtroListar()
    },
    methods: {
      handlerFiltro (value, tipo) {
        //tipo deve ser igual a propriedade desejada no filtro do Store.
        this.$store.dispatch('frenteCaixa/atualizarFiltro', {value, tipo})
      },
      async filtroListar () {
        try {
          loader({text: 'buscando pedidos', active: true})
          // Caso não tenha caixa na data atual, retorna ultimo caixa
          // apenas para ter o saldo final anterior, não deve listar e deve zerar os pedidos
          if (this.caixa.ultimoCaixa) {
            return this.$store.dispatch('frenteCaixa/getPedidos', [])
          }
          const data = await pedidoService.filterPedido(this.filtroStore)
          // Seta propriedade para check tabelaPendentes
          data.data.forEach(item => {
            item.check_pendentes = false
            item.valorTotal = item.ordemServico ? item.ordemServico.valor_total :
              item.lancamentosAvulso ? item.lancamentosAvulso.valor_total : ''
          })
          // Atualiza Store
          this.$store.dispatch('frenteCaixa/getPedidos', data.data)
          //Adiciona o total de paginas ao store
          this.handlerFiltro(data.lastPage, 'lastPage')
          // Atualiza propriedade separada para rederizar tabelas concluidos
          this.$store.dispatch('frenteCaixa/atualizarTipoDeFiltro', this.filtroStore.tipoServico)
          // busca as despesas do dia e atualiza store
          await this.getDespesas()
          // busca as saldo do dia e atualiza store
          await this.getSaldo()
        } catch (error) {
          const message = getErrors(error)
          displayMessage('error', 'Erro!', message.message)
        } finally {
          loader({active: false, text: null})
        }
      },
      async getSaldo () {
        if (!this.caixa.caixa_id) return displayMessage('error', 'Aviso!', 'Não há caixa aberto hoje, abra para continuar')
        try {
          loader({text: 'buscando pedidos', active: true})
          let saldoDia = await pedidoService.getSaldo(this.caixa.caixa_id)

          // Soma saldo de abertura do caixa
          saldoDia.pedidos.saldoTotal = saldoDia.pedidos.saldoTotal + saldoDia.pedidos.saldoAnterior
          
          this.dataFinanceiro.pedidos = saldoDia.pedidos
          this.dataFinanceiro.formaPg = saldoDia.formaPg
          this.dataFinanceiro.tipoPg = saldoDia.tipoPg
          this.dataFinanceiro.pagamentosAvulso = saldoDia.pagamentosAvulso
          this.dataFinanceiro.sangriaCx = saldoDia.sangriaCx

          this.$store.dispatch('frenteCaixa/atualizarSaldo', this.dataFinanceiro) 

        } catch (error) {
          const message = getErrors(error)
          displayMessage('error', 'Erro!', message.message)
        } finally {
          loader({active: false, text: null})
        }
        
      },
      async getDespesas () {
        try {
          const despesas = await lancamentoService.getDespesas(this.caixa.caixa_id)
          this.$store.dispatch('frenteCaixa/atualizaDespesas', despesas)
        } catch (error) {
          const message = getErrors(error)
          displayMessage('error', 'Erro!', message.message)
        }
      },
      previousPage () {
        this.handlerFiltro(this.filtroStore.page - 1, 'page')   
      },
      nextPage () {
        this.handlerFiltro(this.filtroStore.page + 1, 'page')   
      },
    }

  })
</script>

<style scope>
.filtro-pendente {
  margin-left: -12px;
}
</style>
